import { Icon } from '@/components/atoms'
import { useState } from 'react'

const SidebarMenu = () => {
  const [isOpen, setIsOpen] = useState(false)

  const toggleMenu = () => {
    setIsOpen(state => !state)
  }

  const closeMenu = () => {
    setIsOpen(false)
  }

  return (
    <>
      <nav
        data-testid="side-menu"
        className={`shadow-lg absolute z-10 flex h-full flex-col bg-layer-01 ${isOpen ? 'w-64' : 'w-20'}`}
      >
        {!isOpen && (
          <div
            className="mb-4 flex h-14 w-full cursor-pointer items-center pl-8"
            title="Open menu"
            onClick={toggleMenu}
          >
            <Icon icon={'menu'} className="text-text-primary hover:text-text-black" />
          </div>
        )}
        {isOpen && (
          <div className="mb-4 flex h-14 w-full items-center pl-8 pr-4" title="Close menu">
            <Icon
              icon={'menu'}
              size="medium"
              className="cursor-pointer text-text-primary hover:text-text-black"
              onClick={closeMenu}
            />
            <span className="cursor-pointer pl-4 text-text-primary hover:text-text-black" onClick={closeMenu}>
              Menu
            </span>
          </div>
        )}
      </nav>
      {isOpen && <div className="absolute z-[9] h-screen w-screen cursor-default bg-gray-400/60" onClick={closeMenu} />}
    </>
  )
}

export default SidebarMenu
